import React from 'react';
import { FaGithub, FaInstagram, FaTelegram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  const socials = [
    {
      label: 'GitHub',
      a: 'https://github.com/MrAbhi2k3',
      Icon: FaGithub,
    },
    {
      label: 'Telegram',
      a: 'https://t.me/MrAbhi2k3',
      Icon: FaTelegram,
    },
    {
      label: 'Instagram',
      a: 'https://www.instagram.com/mrabhi_2k3/',
      Icon: FaInstagram,
    },
  ];

  return (
    <footer className="border-t border-slate-200/80 bg-[#FAF9F6] pt-12 pb-8 text-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pb-8 border-b border-slate-200">
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-1">
              <span className="font-extrabold text-xl text-slate-900 tracking-tight">DevSponsor</span>
              <span className="text-xs uppercase font-bold tracking-wider px-2.5 py-1 rounded-full bg-slate-200 text-slate-800">
                100% Direct Developer Funding
              </span>
            </div>
            <p className="text-sm text-slate-600 font-medium">
              Supporting independent software creators, open-source maintainers, and community tools.
            </p>
          </div>

          <div className="flex items-center gap-3">
            {socials.map((social, index) => {
              const Icon = social.Icon;
              return (
                <a
                  href={social.a}
                  key={index}
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-xl bg-white border border-slate-200/80 shadow-sm flex items-center justify-center text-slate-700 hover:text-slate-900 hover:bg-slate-50 hover:border-slate-300 transition duration-150"
                >
                  <Icon className="text-base" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between text-sm text-slate-600 font-medium gap-3">
          <p>
            © {new Date().getFullYear()} Developed & maintained by{" "}
            <a 
              className="text-slate-900 font-bold hover:underline" 
              href="https://github.com/MrAbhi2k3"
              target="_blank"
              rel="noopener noreferrer"
            >
              @MrAbhi2k3
            </a>
            . Released under Open Source.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/upi" className="hover:text-slate-900 transition font-semibold">Instant UPI</Link>
            <span>•</span>
            <Link to="/paypal" className="hover:text-slate-900 transition font-semibold">PayPal Global</Link>
            <span>•</span>
            <Link to="/crypto" className="hover:text-slate-900 transition font-semibold">Web3 Grants</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
